/**
 * Automatically keeps a configured "packaging fee" add-on product in sync
 * with the presence of live animal products (tagged "Fisch-Finder") in the
 * cart:
 *  - If the cart contains at least one "Fisch-Finder" tagged product and the
 *    add-on product is missing (or its quantity isn't 1), it is added/fixed
 *    to quantity 1.
 *  - If no "Fisch-Finder" tagged product remains in the cart, the add-on
 *    product is removed automatically.
 *
 * The theme setting `settings.packaging_fee_product` controls which
 * product is used. If it is left blank, this script is a no-op.
 */
(function () {
	if (typeof PUB_SUB_EVENTS === "undefined") return;

	const STATUS_SECTION_ID = "cart-packaging-fee-status";
	const EVENT_SOURCE = "packaging-fee-addon";

	class PackagingFeeCartAddon {
		constructor() {
			this.isSyncing = false;
			this.needsResync = false;

			subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
				if (event && event.source === EVENT_SOURCE) return;
				this.sync();
			});

			if (document.readyState === "loading") {
				document.addEventListener("DOMContentLoaded", () => this.sync());
			} else {
				this.sync();
			}
		}

		sync() {
			if (this.isSyncing) {
				this.needsResync = true;
				return;
			}
			this.isSyncing = true;

			this.getStatus()
				.then((status) => {
					if (!status || !status.addonVariantId) return;

					const addonInCart = Boolean(status.addonLine);

					if (
						status.hasLiveAnimal &&
						(!addonInCart || status.addonQuantity !== 1)
					) {
						return this.addPackagingFeeProduct(status.addonVariantId);
					}

					if (!status.hasLiveAnimal && addonInCart) {
						return this.removeAddon(status.addonLine);
					}
				})
				.catch((error) => console.error(error))
				.finally(() => {
					this.isSyncing = false;
					if (this.needsResync) {
						this.needsResync = false;
						this.sync();
					}
				});
		}

		getStatus() {
			return fetch(
				`${routes.cart_url}?section_id=${STATUS_SECTION_ID}`,
			)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(
						responseText,
						"text/html",
					);
					const dataElement = html.querySelector(
						"[data-cart-packaging-fee-status]",
					);
					if (!dataElement) return null;

					try {
						return JSON.parse(dataElement.textContent);
					} catch (error) {
						console.error(error);
						return null;
					}
				});
		}

		getSectionsToRender() {
			const sections = [];

			sections.push({
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			});

			if (document.getElementById("CartDrawer")) {
				sections.push({
					id: "CartDrawer",
					section: "cart-drawer",
					selector: ".drawer__inner",
				});
			}

			const mainCartItems = document.getElementById("main-cart-items");
			if (mainCartItems) {
				sections.push({
					id: "main-cart-items",
					section: mainCartItems.dataset.id,
					selector: ".js-contents",
				});
			}

			const mainCartFooter = document.getElementById("main-cart-footer");
			if (mainCartFooter) {
				sections.push({
					id: "main-cart-footer",
					section: mainCartFooter.dataset.id,
					selector: ".js-contents-totals",
				});
			}

			const mainCartItemsWrapper = document.getElementById(
				"main-cart-items-wrapper",
			);
			if (mainCartItemsWrapper) {
				sections.push({
					id: "main-cart-items-wrapper",
					section: mainCartItemsWrapper.dataset.id,
					selector: ".js-cart-count",
				});
			}

			const mainCartShipping = document.getElementById("main-cart-shipping");
			if (mainCartShipping) {
				sections.push({
					id: "main-cart-shipping",
					section: mainCartShipping.dataset.id,
					selector: ".js-contents-shipping",
				});
			}

			return sections;
		}

		renderSections(sectionsMarkup) {
			this.getSectionsToRender().forEach((section) => {
				const html = sectionsMarkup[section.section];
				const container = document.getElementById(section.id);
				if (!html || !container) return;

				const parsedSection = new DOMParser()
					.parseFromString(html, "text/html")
					.querySelector(section.selector);
				if (!parsedSection) return;

				const target = container.querySelector(section.selector) || container;
				target.innerHTML = parsedSection.innerHTML;
			});
		}

		addPackagingFeeProduct(variantId) {
			const body = JSON.stringify({
				id: variantId,
				quantity: 1,
				sections: this.getSectionsToRender().map((section) => section.section),
				sections_url: window.location.pathname,
			});

			return fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } })
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						console.error(response.description || response.message);
						return;
					}
					if (response.sections) this.renderSections(response.sections);
					publish(PUB_SUB_EVENTS.cartUpdate, { source: EVENT_SOURCE });
				});
		}

		removeAddon(line) {
			const body = JSON.stringify({
				line,
				quantity: 0,
				sections: this.getSectionsToRender().map((section) => section.section),
				sections_url: window.location.pathname,
			});

			return fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } })
				.then((response) => response.json())
				.then((response) => {
					if (response.sections) this.renderSections(response.sections);
					publish(PUB_SUB_EVENTS.cartUpdate, { source: EVENT_SOURCE });
				});
		}
	}

	window.PackagingFeeCartAddon = new PackagingFeeCartAddon();
})();
